<template>
  <span>
    <ViewBar :hidden="true"></ViewBar>
    <div>
      <v-tabs fixed-tabs slot="extension" v-model="selectedTab">
        <v-tab
          v-for="{key, label} in configurationTabs"
          :key="key"
          :href="`#tab-${key}`"
          :id="`tab-link-${key}`"
          @click="click(key)"
        >{{ $t(label) }}</v-tab>
        <v-tab-item
          v-for="{key, label, component} in configurationTabs"
          :value="`tab-${key}`"
          :key="key"
        >
          <component v-bind:is="component"></component>
        </v-tab-item>
      </v-tabs>
    </div>
  </span>
</template>

<script>
import Groups from "../components/users/Groups";
import Users from "../components/users/Users";
import ViewBar from "../components/viewbar/ViewBar";
import Roles from "../components/users/Roles";
import { mapGetters } from 'vuex';

const DEFAULT_TAB = "tab-groups"

export default {
  components: {
    Groups,
    Users,
    Roles,
    ViewBar,
  },
  data() {
    return {
      selectedTab: DEFAULT_TAB,
    };
  },
  mounted() {
    this.$defaultTab = this.canWriteAnyGroup ? DEFAULT_TAB : "tab-users"
    let selectedTab = this.$route.params.selectedTab;
    if (selectedTab) {
      this.selectedTab = `tab-${selectedTab}`;
    } else {
      this.selectedTab = this.$defaultTab || DEFAULT_TAB
    }
  },
  watch: {
    '$route.params.selectedTab': function (selectedTab) {
      if (selectedTab) {
        if (this.selectedTab !== selectedTab)
          this.selectedTab = `tab-${selectedTab}`;
      } else {
        this.selectedTab = this.$defaultTab || DEFAULT_TAB
      }
    }
  },
  computed: {
  ...mapGetters("auth", ["canWriteAnyGroup"]),
    configurationTabs() {
      const result = []
      if (this.canWriteAnyGroup) {
        result.push({
          key: "groups",
          label: "usersGroups.label.groups",
          component: "Groups"
        })
      }
      result.push({
        key: "users",
        label: "users.label.users",
        component: "Users"
      })
      result.push({
        key: "roles",
        label: "roles.label.roles",
        component: "Roles"
      })
      return result;
    }
  },
  methods: {
    click(selectedTab) {
      this.$router.push({name: 'adminByParams', params: {selectedTab}})
    }
  }
};
</script>
